import React from 'react';
import { CartItem, targetAppStore } from '../store';
import { Trash2, Plus, Minus, ShoppingCart } from 'lucide-react';

interface CartSidebarProps {
  cart: CartItem[];
}

export const CartSidebar: React.FC<CartSidebarProps> = ({ cart }) => {
  const subtotal = cart.reduce((acc, item) => acc + item.product.price * item.quantity, 0);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h3 style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-1)', display: 'flex', alignItems: 'center', gap: 6 }}>
          <ShoppingCart size={14} style={{ color: 'var(--accent)' }} /> Active Cart ({cart.reduce((a, c) => a + c.quantity, 0)} items)
        </h3>
        <span style={{ fontSize: 11, fontFamily: 'var(--font-mono)', color: 'var(--text-2)' }}>
          Subtotal: ${subtotal.toFixed(2)}
        </span>
      </div>

      {cart.length === 0 ? (
        <div
          style={{
            padding: '24px 16px',
            textAlign: 'center',
            color: 'var(--text-3)',
            background: 'var(--bg-card)',
            borderRadius: 'var(--radius-md)',
            border: '1px dashed var(--border)',
            fontSize: 12,
          }}
        >
          Cart is empty. Add products from the catalog above.
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {cart.map(({ product, quantity }) => (
            <div
              key={product.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '8px 10px',
                background: 'var(--bg-card)',
                borderRadius: 'var(--radius-sm)',
                border: '1px solid var(--border)',
                fontSize: 12,
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 16 }}>{product.imageEmoji}</span>
                <div>
                  <div style={{ fontWeight: 500, color: 'var(--text-1)' }}>{product.name}</div>
                  <div style={{ fontSize: 11, color: 'var(--text-3)' }}>
                    {product.price === 0 ? 'FREE GIFT' : `$${product.price.toFixed(2)} each`}
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    background: 'var(--bg-input)',
                    borderRadius: 4,
                    border: '1px solid var(--border)',
                  }}
                >
                  <button
                    onClick={() => targetAppStore.updateQuantity(product.id, quantity - 1)}
                    style={{
                      background: 'none',
                      border: 'none',
                      color: 'var(--text-2)',
                      padding: '2px 5px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Minus size={10} />
                  </button>
                  <span style={{ padding: '0 6px', fontSize: 11, fontFamily: 'var(--font-mono)', color: 'var(--text-1)' }}>
                    {quantity}
                  </span>
                  <button
                    onClick={() => targetAppStore.updateQuantity(product.id, quantity + 1)}
                    style={{
                      background: 'none',
                      border: 'none',
                      color: 'var(--text-2)',
                      padding: '2px 5px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Plus size={10} />
                  </button>
                </div>

                <button
                  onClick={() => targetAppStore.removeFromCart(product.id)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: 'var(--text-3)',
                    cursor: 'pointer',
                    padding: 4,
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  title="Remove item"
                >
                  <Trash2 size={12} />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
